import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=08d917f6&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=08d917f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d917f6",
  null
  
)

export default component.exports